import React, { Component } from "react";

export class EnquiryModal extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    window.EnquiryModal = this;
  }
  render() {
    let { props } = this;
    let { id, title, onClose } = props;
    let attrs = Object.except(props, ["id", "title", "type", "onClose"]);

    return (
      <AppModalBs id={id} title={title} onClose={onClose}>
        <AppFormData {...attrs} onClose={onClose}></AppFormData>
      </AppModalBs>
    );
  }
}

export default EnquiryModal;
